import React, { useContext } from "react";
import ParamsContext from "../../utils/context/paramsContext";
import FaceScanErrorScreen from "./FaceScanErrorScreen";
import LoadingScreen from "../LoadingScreen";
import { videoConstraints } from "../../utils/constants";
import { Drawer } from "@mui/material";
import FaceScanGuide from "./FaceScanGuide";
import Modal from "../Modal";
import { FaceScanErrorType } from "../../utils/enums";
import { ArrowRight } from "lucide-react";
import { useConfig } from "../../utils/context/configContext";
interface FaceScanStepProps {
	webcamRef: React.RefObject<HTMLVideoElement | null>;
	canvasRef: React.RefObject<HTMLCanvasElement | null>;
}

const FaceScanStep: React.FC<FaceScanStepProps> = ({ webcamRef, canvasRef }) => {
	const {
		isError,
		isSuccess,
		showLoader,
		hasError,
		errorType,
		resetScanState,
		showGuideCard,
		scanStage,
		videoLoading,
		setVideoLoading,
		videoError,
		setVideoError,
		gender,
		getButtonText,
		isScanning,
		startScan,
		isModelLoaded,
		onRetry,
	} = useContext(ParamsContext);
	const resolvedConfig = useConfig();
	if (isError) {
		return <FaceScanErrorScreen onRetry={onRetry} />;
	}
	if (isSuccess) {
		return (
			<div className="fixed z-[9] common-ui-main  w-full h-full" style={{ background: resolvedConfig?.style?.base?.backgroundColor }}>
				<LoadingScreen url={resolvedConfig?.loader} loaderType="black" />
			</div>
		);
	}

	return (
		<>
			<audio id="audioElement" crossOrigin="anonymous" preload="auto" style={{ position: "absolute", zIndex: -99999 }} src={undefined} />

			{/* Error overlay */}
			{showLoader && !hasError && (
				<div className="fixed z-[9] common-ui-main  w-full h-full" style={{ background: resolvedConfig?.style?.base?.backgroundColor }}>
					{/* <Asset genderType={gender} /> */}
					<LoadingScreen url={resolvedConfig?.loader} loaderType="black" />
				</div>
			)}

			{/* Always show camera view */}
			<div className="h-full flex-col common-ui-main relative w-full flex justify-center items-center text-center  rounded-t-[20px]" style={{ background: resolvedConfig?.style?.base?.backgroundColor }}>
				<div className="flex-1 w-full max-w-md overflow-hidden">
					<div className="w-full h-full">
						<video
							ref={webcamRef}
							autoPlay
							playsInline
							muted
							width={videoConstraints.width.ideal}
							height={videoConstraints.height.ideal}
							className="w-full h-full object-cover fixed left-0 top-0 z-0"
							style={{ transform: "scaleX(-1)" }}
						/>
						<canvas ref={canvasRef} width={videoConstraints.width.ideal} height={videoConstraints.height.ideal} style={{ transform: "scaleX(-1)", opacity: "0" }} />
					</div>
				</div>
			</div>

			{/* Error overlay */}
			{!showLoader && hasError && errorType === FaceScanErrorType.Camera && (
				<Modal testId="face-scan-camera-error-screen" config={resolvedConfig} />
			)}
			{!showLoader && hasError && errorType !== FaceScanErrorType.Camera && (
				<FaceScanErrorScreen loading={showLoader} onRetry={resetScanState} />
			)}

			{/* Scan guide drawer - only show when scanning */}
			{showGuideCard && !hasError && !showLoader && (
				<Drawer
					open
					className="face-scan-small camera-draw"
					anchor="bottom"
					onClose={(event, reason) => {
						if (reason === "backdropClick") {
							return;
						}
					}}
					hideBackdrop
				>
					<FaceScanGuide
						stage={scanStage}
						videoLoading={videoLoading}
						setVideoLoading={setVideoLoading}
						videoError={videoError}
						setVideoError={setVideoError}
						gender={gender}
						btnConfig={{
							label: getButtonText(),
							onClick: isScanning ? resetScanState : startScan,
							isDisabled: showLoader || !isModelLoaded,
							icon: isScanning ? <ArrowRight /> : <></>,
						}}
					/>
				</Drawer>
			)}
		</>
	);
};

export default FaceScanStep;
